import React from "react";
import { FiHome, FiUsers, FiMessageSquare, FiGrid } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";

const tabs = [
  { name: "Home", icon: FiHome, path: "/" },
  { name: "Community", icon: FiUsers, path: "/community" },
  { name: "Messages", icon: FiMessageSquare, path: "/messages" },
  { name: "My Posting", icon: FiGrid, path: "/my-posting" },
];

const BottomNavbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-black text-white shadow-lg z-10 
                    flex justify-around items-center py-2 md:hidden"
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const active = pathname === tab.path;

        return (
          <button
            key={tab.name}
            onClick={() => navigate(tab.path)}
            className="flex flex-col items-center justify-center"
          >
            <div
              className={`p-1 rounded-full transition-all duration-300 
                ${
                  active ? "bg-blue-500 text-white scale-110" : "text-gray-400"
                }`}
            >
              <Icon className="text-xl" />
            </div>

            <p
              className={`text-xs mt-1 ${
                active ? "text-blue-400" : "text-gray-400"
              }`}
            >
              {tab.name}
            </p>
          </button>
        );
      })}
    </div>
  );
};

export default BottomNavbar;
